module.exports = __webpack_public_path__ + "img/رسمی.49f8c2cd.jpg";